import { BaseApi } from './base.api.js';

export class PrivacyPrincipleApi extends BaseApi {
    constructor(client) {
        super(client, '/privacy-principle');
    }
}
